import React from 'react';

import RichText from 'components/RichText/RichText';
import useOverElement from 'hooks/useOverElement';

import * as S from '../AboutPage.styles';

export interface TextContentSectionProps {
  title: string;
  mainTextContent: string;
}

const TextContentSection: React.FunctionComponent<TextContentSectionProps> = ({
  title,
  mainTextContent,
}) => {
  const [ref] = useOverElement();

  return (
    <S.TextContentSectionGrid ref={ref}>
      <S.TextContentSectionWrapper>
        <div>{title && <RichText richText={title} />}</div>

        {mainTextContent && <RichText richText={mainTextContent} />}
      </S.TextContentSectionWrapper>
    </S.TextContentSectionGrid>
  );
};

export default TextContentSection;
